export default "/wp-content/themes/oportun/dist/assets/brand/graphics-9a32387d1a799542.svg"